import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import ContactBitkala from '../Components/ContactBitkala';
import ScrollAnimation from 'react-animate-on-scroll';


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }

  state = {
    detailList: [],
    editId: -1
  }


  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  setDetailList(data) {

    this.setState(prevState => {
      return {
        detailList: data,
        editId: -1
      }
    })

  }

  editDetail(id) {
    this.setState(prevState => {
      return {
        editId: id
      }
    })
  }

  newEvent() {
    this.setState(prevState => {
      return {
        detailList: [{ Id: 0, Description: '', Tag: '' }],
        editId: 0
      }
    })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

  }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
        <div class="header_section">
          <ScrollAnimation animateIn="fadeIn">
            <div>
              <div class="container">
                <div class="maz_fulltext">
                  <h1>طراحی و تولید وب اپلیکیشن حرفه ای&nbsp;</h1>
                  <p>معمولا یک اپلیکیشن برای برای برآورده کردن یک سری انتظارات خاص بیزینسی ایجاد می شود و انتظار میرود که پس از تولید نرم افزار نیازمندی ما به اتوماسیون بخش از کسب و کار که هدف تولید پروژه بوده را برآورده سازد . انتظارات مشترکی که از نرم افزار ها ی تولید شده وجود دارد عبارتند از:</p>
                  <p>&nbsp;بعد تولید نرم افزار انتظار داریم که کاربر نهایی چه مشتری باشد چه کارمندان سازمان بتوانند به راحتی با نرم افزار ارتباط برقرار کرده و در هنگام کار با &nbsp;نرم افزار تا حدممکن از ورود اطلاعات اشتباه توسط کارمند یا مشتری جلو گیری شود در عین حال مشتری یا کارمند درون نرم افزار علت خطای خود را متوجه شود و به راحتی آن را اصلاح نمایند. از طرفی نرم افزار باید طوری برنامه نویسی شده باشد که اضافه کردن ماژول های جدید به آن با کمترین هزینه &nbsp;از نظر زمانی و از نظر اقتصادی انجام شود . رعایت اصول برنامه نویسی در رسیدن به هدف سرعت ارتقا نرم افزار بسیار مهم است و این که نرم افزار تا آنجایی که ممکن است به صورت ماژولار نوشته شده باشد.تا اجرای مراحل تست به راحتی ممکن شود و بتوان انواع تست را به صورت اتومات روی آن اجرایی کرد.</p>
                  <p>سرعت اجرای قسمت های نرم افزار بسیار مهم است . به عنوان مثال در هنگام گزارش گیری از اطلاعات موجود در دیتا بیس نرم افزار وقتی جداول متعدد باشند و داده های زیاد در جداول موجود باشد با تاخیر قابل توجهی مواجه می شود و اگر تکتولوژیهای نامناسب استفاده شده باشد هزینه بالایی برای بالا بردن سرعت اجرای قسمتهای مختلف ،چه از نظر اقتصادی و چه از نظر زمانی باید پرداحت شود.</p>
                  <p>نتیجه این که تولید یک اپلیکیشن آینده دار باید توسط تیم حرفه ای با مدیریت حرفه ای و با تجربه انجام شود که به مشکلات ارتقا و هزینه بالای نگهداری نرم افزار &nbsp;مواجه نشویم.</p>
                  <p>تیم بیت کلا همه موارد مورد نیاز برای پروزه را در نظر می گیرد و با تجاربی که از قبل اندوخته است نرم افزاری بسیار بهینه را تولید می نماید.</p>
                  <h1>مراحل تولید وب اپلیکیشن&nbsp;</h1>

                  <h3>مرحله ۱: معماری</h3>
                  <p>قبل از شروع کار، معماری سیستم ، داده و فناوری متناسب با طرح کسب وکار تعریف و مستند می شود تا به عنوان نقشه راه در کل مسیراستفاده شود.</p>

                  <h3>مرحله ۲: طراحی</h3>
                  <p>بر اساس هویت بصری کسب و کار ، طراحی گرافیکی برای اپلیکیشن انجام می شود. این طرح‌ها هویت بصری اپلیکیشن را از نظر بصری مشخص می کنند.</p>

                  <h3>مرحله ۳: پیاده سازی</h3>
                  <p>در این مرحله بعد از تایید طرح گرافیکی توسط مشتری، پیاده سازی شروع و کارهای کد نویسی اپلیکیشن انجام می شود.</p>

                  <h3>مرحله ۴: تست</h3>
                  <p>تست نرم افزار پس از اتمام مرحله پیاده سازی الزامی است. این تست صرفا در محدوده تست امکانات خلاصه نمی شود و با رویکردی فنی شامل تست کدها، بانک اطلاعات، عملکرد و کارایی نیز می شود. البته ابزارهای تست برای پروژه های مختلف متقاوت است.</p>

                  <h3>مرحله ۵: آموزش و تحویل</h3>
                  <p>پس از اتمام مراحل تولید در یک جلسه آموزشی، کلیه مستندات لازم به همراه آموزش های کاربردی پنل به مشتری ارائه می شود.</p>

                </div>
              </div>
              <ContactBitkala></ContactBitkala>
              <div class="container">
                <div class="maz_fulltext">

                  <h2>سوالات متداول:</h2>

                  <p><strong>برای داشتن وب اپلیکیشن حرفه ای چه کاری باید انجام دهیم ؟</strong></p>
                  <p>ابتدا می بایست تا درکی درست از اهداف و چشم اندازهای خود داشته باشید. همانطور که طراحی اتوماسیون مبتنی بر وب فرآیندهای شما را سرعت می بخشد، به همان میزان می تواند سبب کندی دراجرای فرآیند های شما شود.</p>
                  <p><strong>تکنولوژی های مورد استفاده بیت کالا برای تهیه وب اپلیکیشن چه می باشد ؟</strong></p>
                  <p>با توجه به نوع پروژه ، انتخاب تکنولوژی متفاوت است. در ادامه برخی از تکنولوژی های مورد استفاده ذکر می&nbsp; شوند.</p>
                  <p>استفاده از زبان فرامتنی قابل توسعه XML</p>
                  <p>استفاده از زبان های اسکریپت نویسی تحت کلاینت&nbsp;JAVASCRIPT&nbsp;و بهره گیری از&nbsp;JQUERY&nbsp;برای طراحی افکت ها و افزودن قابلیت های تعامل پذیری زیبا</p>
                  <p>استفاده از زبان های برنامه نویسی&nbsp;PHP&nbsp;,&nbsp;ASP&nbsp;,&nbsp;NODE JS&nbsp;برای توسعه پنل های کارآمد</p>
                  <p>استفاده از سرورهای لینوکس و ویندوز، که وابسته به زبان برنامه نویسی انتخابی دارد.</p>
                  <p>استفاده از دیتابیس&nbsp;MONGO&nbsp;,&nbsp;MYSQL&nbsp;,&nbsp;SQL SERVER&nbsp;,&nbsp;ORACLE&nbsp;بسته به میزان حجم مورد انتظار و سرعت مورد نیاز می باشد.</p>
                  <p>آیا قابلیت ارائه سورس کد های برنامه وجود دارد ؟</p>
                  <p>بله . هزینه ارائه سورس برنامه نسبت به نوع پروژه ها متفاوت می باشد.</p>

                  <p><strong>ما یک شرکت کوچک هستیم. حداقل هزینه طراحی وب اپلیکیشن چقدر است ؟</strong></p>
                  <p>پایین ترین هزینه برای راه اندازی یک&nbsp;اپلیکیشن تحت وب&nbsp;۶ میلیون تومان می باشد.</p>

                  <p><strong>پشتیبانی رایگان شما بعد از تحویل پروژه چند ماه می باشد ؟</strong></p>
                  <p>سه ماه</p>
                  <p><strong>آیا آموزش پنل کاربری وب اپلیکیشن بعد از تحویل پروژه رایگان است ؟</strong></p>
                  <p>بله. ارائه یک مرتبه آموزش کامل همراه با فیلم آموزشی به نماینده کارفرما رایگان می باشد.</p>

                  <p><strong>شرکت دیگری برنامه ما را برنامه نویسی کرده و الان می خواهیم توسعه اپلیکیشن را به بیت کالا بسپاریم. آیا امکان پذیر است ؟</strong></p>
                  <p>پس از بررسی سورس کدها و زیرساخت فنی ، امکان انجام آن معین و اعلام می شود.</p>

                </div>
              </div>
            </div>

          </ScrollAnimation>
        </div>


      </>
    )
  }
}


